// Default avatar URL used throughout the application
// export const DEFAULT_AVATAR = 'https://api.dicebear.com/7.x/avataaars/svg'
export const DEFAULT_AVATAR = '/jeridoo.png'
// CDN server URL
export const CDN_BASE_URL = 'http://46.101.199.181/cdn'

// Other global constants can be added here
